
import { defineComponent, onMounted, PropType, Ref, ref } from 'vue'

export type View = {id: string, name: string}
export type ViewIndex = 0 | 1

export default defineComponent({
  props: {
    viewArray: {
      type: Array as PropType<Array<View>>,
      required: true
    },
    defaultViewIndex: {
      type: Number as PropType<ViewIndex>,
      default: 0
    }
  },
  emits: ['click'],
  setup (props, { emit }) {

    const activeViewId: Ref<string> = ref('')

    const handleClick = (viewId: string): void => {
      emit('click', viewId)
      activeViewId.value = viewId
    }

    onMounted(() => {
      activeViewId.value = props.viewArray[props.defaultViewIndex].id
    })

    return {
      handleClick,
      activeViewId
    }
  }
})

